import { hexToRgba } from '@/app-shared/utils/tool';

let customColor = {
  '--chat-bg-color-checkbox-checked': '#fb2626',
  '--theme-color': '#fb2626',
  '--theme-color-sub': '#fb2626',
  '--theme-color-main': '#fb2626',
  '--theme-component-subscribe': '#fb2626',
  '--chapter-font-color-active': '#fb2626',
  '--login-tab-color': '#fb2626',
  '--login-background-button': '#fb2626',
  '--theme-more-status-button-bg': '#fb2626',
  '--theme-more-status-button-border': '#fb2626',
  '--theme-more-status-button-hover-bg': '#fb2626',
  '--theme-more-status-button-hover-border': '#fb2626',
  '--theme-more-status-button-active-bg': '#fb2626',
  '--theme-more-status-button-active-border': '#fb2626',
  '--theme-more-status-button-disabled-bg': '#fb2626',
  '--theme-more-status-button-disabled-border': '#fb2626',
  '--theme-notice-column-text': '#ec7b03',
  '--theme-notice-column-icon': '#ec7b03',
  '--theme-notice-border': '#ffc5c3',
  '--theme-sign-bg': '#fb2626',
  '--theme-question-border': 'rgba(253, 170, 167, 1)',
  '--theme-welcome-greeting-bg': 'rgba(255, 172, 44, 0.8)',
  '--chat-role-name-host-bg': 'rgba(251, 38, 38, 0.15)',
  '--chat-role-name-assistant-bg': 'rgba(10, 127, 245, 0.15)',
  '--chat-role-name-assistant-text': '#33a0ff',
  '--qa-role-name-host-bg': 'rgba(251, 38, 38, 0.15)',
  '--qa-role-name-host-text': 'rgba(251, 38, 38, 1)',
  '--qa-role-name-assistant-bg': 'rgba(10, 127, 245, 0.15)',
  '--qa-role-name-assistant-text': 'rgba(10, 127, 245, 1)'
};

export const setColors = color => {
  customColor = {
    '--chat-bg-color-checkbox-checked': color,
    '--theme-color': color,
    '--theme-color-sub': hexToRgba(color, 0.09),
    '--theme-color-main': color,
    '--theme-component-subscribe': color,
    '--chapter-font-color-active': color,
    '--login-tab-color': color,
    '--login-background-button': color,
    '--theme-more-status-button-bg': color,
    '--theme-more-status-button-border': color,
    '--theme-more-status-button-hover-bg': color,
    '--theme-more-status-button-hover-border': color,
    '--theme-more-status-button-active-bg': color,
    '--theme-more-status-button-active-border': color,
    '--theme-more-status-button-disabled-bg': color,
    '--theme-more-status-button-disabled-border': color,
    '--theme-notice-column-icon': color,
    '--theme-notice-border': hexToRgba(color, 0.4),
    '--theme-sign-bg': hexToRgba(color, 0.7),
    '--theme-question-border': hexToRgba(color, 0.5),
    '--theme-welcome-greeting-bg': hexToRgba(color, 0.5),
    '--chat-role-name-host-bg': hexToRgba(color, 0.15),
    '--chat-role-name-assistant-bg': hexToRgba(color, 0.15),
    '--chat-role-name-assistant-text': color,
    '--qa-role-name-host-bg': hexToRgba(color, 0.15),
    '--qa-role-name-host-text': color,
    '--qa-role-name-assistant-bg': hexToRgba(color, 0.15),
    '--qa-role-name-assistant-text': color,
    '--theme-notice-column-bg': hexToRgba(color, 0.85)
  };
  return customColor;
};
